var _a, _b;
import { __assign } from "tslib";
import { handleActions } from 'redux-actions';
import { addToGroupFolderSuccess, addToGroupFolderFail, addToGroupFolder, } from './actions';
import { getGroupFolderKey } from './helpers';
import { reduxKey } from './constants';
var actionHandlers = handleActions((_a = {},
    _a[addToGroupFolder.toString()] = function (state, _a) {
        var _b;
        var _c = _a.payload, deviationId = _c.deviation.deviationId, groupFolderId = _c.groupFolderId;
        return (__assign(__assign({}, state), (_b = {}, _b[getGroupFolderKey(deviationId, groupFolderId)] = {
            loading: true,
            added: false,
            suggested: false,
        }, _b)));
    },
    _a[addToGroupFolderSuccess.toString()] = function (state, _a) {
        var _b;
        var _c = _a.payload, deviationId = _c.deviationId, groupFolderId = _c.groupFolderId, suggested = _c.suggested;
        return (__assign(__assign({}, state), (_b = {}, _b[getGroupFolderKey(deviationId, groupFolderId)] = {
            loading: false,
            added: !suggested,
            suggested: suggested,
        }, _b)));
    },
    _a[addToGroupFolderFail.toString()] = function (state, _a) {
        var _b;
        var _c = _a.payload, deviationId = _c.deviationId, groupFolderId = _c.groupFolderId;
        return (__assign(__assign({}, state), (_b = {}, _b[getGroupFolderKey(deviationId, groupFolderId)] = {
            loading: false,
            added: false,
            suggested: false,
        }, _b)));
    },
    _a), {});
export default (_b = {},
    _b[reduxKey] = actionHandlers,
    _b);
//# sourceMappingURL=reducer.js.map